import { render, staticRenderFns } from "./Notifications.vue?vue&type=template&id=46fd7ca0&"
import script from "./Notifications.vue?vue&type=script&lang=js&"
export * from "./Notifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/kreston-is.sdev.cz/httpdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46fd7ca0')) {
      api.createRecord('46fd7ca0', component.options)
    } else {
      api.reload('46fd7ca0', component.options)
    }
    module.hot.accept("./Notifications.vue?vue&type=template&id=46fd7ca0&", function () {
      api.rerender('46fd7ca0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/parts/header/Notifications.vue"
export default component.exports